import { useMutation } from '@tanstack/react-query'
import { gameBoxRoomService } from '../../../../services/games/games-boxes-rooms'

export const useCreateGameBoxRoom = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: gameBoxRoomService.create,
  })

  return {
    create: mutateAsync,
    isLoading: isPending,
  }
}
